import clsx from 'clsx';
import Icon from 'components/Icon';
import LinkButton from 'components/LinkButton';
import TableStatic from 'components/Table/TableStatic';
import {FC} from 'react';
import {t} from 'ttag';
import {boolToIconString} from 'utils/functions';

import {notificationTable} from '../styles.module.css';
import {User} from '../types';

type UserProps = {user: User};

const UserTable: FC<UserProps> = ({user}) => (
    <TableStatic
        className={clsx(notificationTable, 'mt-6 w-full min-w-[720px]')}
        hasStripes={true}
        id="user-table"
    >
        <TableStatic.Header>
            <TableStatic.HeaderRow>
                <TableStatic.Column className="whitespace-normal">
                    {t`User Notifications`} - {user.email}
                </TableStatic.Column>
                <TableStatic.Column className="gap-2">
                    <LinkButton
                        href={window.Urls.email_settings_view()}
                        kind="secondary"
                        size="xs"
                    >
                        {t`Manage Emails`}
                    </LinkButton>
                    <LinkButton
                        href={window.Urls.notifications_edit_view()}
                        kind="secondary"
                        size="xs"
                    >
                        {t`Edit Notification Settings`}
                    </LinkButton>
                </TableStatic.Column>
            </TableStatic.HeaderRow>
        </TableStatic.Header>
        <TableStatic.Body>
            <TableStatic.Row>
                <TableStatic.Cell>
                    {t`System Notifications`} -{' '}
                    {t`Important notifications such as password resets.`}
                </TableStatic.Cell>
                <TableStatic.Cell>
                    <Icon icon="enabled_checkbox" size="base" />
                </TableStatic.Cell>
            </TableStatic.Row>
            <TableStatic.Row>
                <TableStatic.Cell>
                    {t`Announcements`} - {t`Roughly 1-2 emails a month.`}
                </TableStatic.Cell>
                <TableStatic.Cell>
                    <Icon
                        icon={boolToIconString(
                            user.settings.isNewsletterEnabled,
                        )}
                        size="base"
                    />
                </TableStatic.Cell>
            </TableStatic.Row>
            <TableStatic.Row>
                <TableStatic.Cell>
                    {t`Onboarding, Tips, Tricks`} -{' '}
                    {t`We occasionally send you a few emails to help you get the most out of MakeLeaps.`}
                </TableStatic.Cell>
                <TableStatic.Cell>
                    <Icon
                        icon={boolToIconString(
                            user.settings.isOnboardingEnabled,
                        )}
                        size="base"
                    />
                </TableStatic.Cell>
            </TableStatic.Row>
        </TableStatic.Body>
    </TableStatic>
);

export default UserTable;
